import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getSelectedBrand, handleLogout } from "@platformx/utilities";
import { getCurrentLang, getSelectedSite } from "../utils/helper";

const defaultOptions: any = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    // errorPolicy: "all",
  },
};
const link = createHttpLink({
  uri: process.env.NX_PUBLIC_GRAPHQL_URI,
  credentials: "include",
});

const updateLanguageheader = setContext((_: any, prevContext: any) => {
  const brandId = getSelectedBrand();
  const skipBrandNameHeader = Boolean(prevContext?.skipBrandNameHeader) || false;
  // Opt-in flags that let a caller supply the sitename/language header explicitly
  // instead of the session-derived defaults. Without these, the unconditional
  // `sitename: getSelectedSite()` below silently clobbers any per-call override —
  // which broke the DAM community mapping when switching sites.
  const useProvidedSiteNameHeader = Boolean(prevContext?.useProvidedSiteNameHeader) || false;
  const useProvidedLanguageHeader = Boolean(prevContext?.useProvidedLanguageHeader) || false;
  const sanitizedHeaders = prevContext?.headers ? { ...prevContext.headers } : {};

  if (skipBrandNameHeader) {
    delete sanitizedHeaders.brandname;
  }

  return {
    headers: {
      ...sanitizedHeaders,
      language:
        useProvidedLanguageHeader && sanitizedHeaders.language
          ? sanitizedHeaders.language
          : getCurrentLang(),
      sitename:
        useProvidedSiteNameHeader && sanitizedHeaders.sitename
          ? sanitizedHeaders.sitename
          : getSelectedSite(),
      ...(!skipBrandNameHeader && brandId ? { brandname: brandId } : {}),
    },
  };
});

const onErrorLink = onError(({ networkError }: any) => {
  if (networkError?.statusCode === 401) {
    handleLogout();
  }
});

const graphqlInstance = new ApolloClient({
  link: ApolloLink.from([onErrorLink, updateLanguageheader, link]),
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
});
export default graphqlInstance;
